/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import DataModel from '@ember-data/model';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import UiDynamicContentEditorV1Component from 'uplisting-frontend/components/ui/dynamic-content-editor/v1';

export default class UiDynamicContentEditorV2Component<
  T extends DataModel,
> extends UiDynamicContentEditorV1Component<T> {
  @tracked selectedTab = 'tags';

  @action
  handleChangeTab(tab: string): void {
    this.selectedTab = tab;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::DynamicContentEditor::V2': typeof UiDynamicContentEditorV2Component;
  }
}
